import React from "react";
import i18n from "../../i18n";
import {assetUrl} from "../../utils/etc";
import {logEvent, userEvents} from "../../utils/log";
import {webviewAnalyticsEvent} from "../../utils/webview";
import clientStorage from "../../utils/client-storage";

const answers = {
  hotlook: "hotlook",
  undress: "undress",
}

class SurveyView extends React.Component {

  state = {
    answer: null,
  };

  spanHeight = 0;
  spanRef = React.createRef();

  componentDidMount() {
    this.spanHeight = this.spanRef.current.getBoundingClientRect().height + 8;

    webviewAnalyticsEvent("goal_alert_banner_shown", [
      clientStorage.getSelectedPhotosAmount(),
    ]);
  }

  handleSetAnswer = (answer) => {
    if (this.state.answer === answer) {
      return;
    }

    this.setState({
      answer
    });

    this.props.onAnswered(answer);

    logEvent(userEvents.SURVEY, {answer});

    webviewAnalyticsEvent("goal_alert_banner_done", [
      clientStorage.getSelectedPhotosAmount(),
      answer === answers.hotlook ? "hot fantasy" : "undressing someone",
    ]);
  }

  render() {
    return <div className="survey-container">
      <h1>{i18n.t("survey_title")}</h1>
      <div className="survey-btns">
        <button
          className={this.state.answer === answers.hotlook ? "active" : ""}
          onClick={() => this.handleSetAnswer(answers.hotlook)}
        >
          <img style={{"--span-height": this.spanHeight + "px"}} src={assetUrl(`assets/images/survey/1temp.jpg`)} alt="" />
          <span
            ref={this.spanRef}
          >{i18n.t("survey_answer_hotlook")}</span>
        </button>
        <div className={`survey-avatar ${this.state.answer ? "active" : ""}`}>
          <img src={assetUrl(`assets/images/survey/original.jpg`)} alt="" />
        </div>
        <button
          className={this.state.answer === answers.undress ? "active" : ""}
          onClick={() => this.handleSetAnswer(answers.undress)}>
          <img style={{"--span-height": this.spanHeight + "px"}} src={assetUrl(`assets/images/survey/2temp.jpg`)} alt="" />
          <span>{i18n.t("survey_answer_undress")}</span>
        </button>
      </div>
    </div>;
  }
}

export default SurveyView;
